var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback__modal__btn" },
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true }
            }
          ],
          staticClass: "feedback-btn",
          attrs: { title: "Send Feedback", variant: "theme" },
          on: {
            click: function($event) {
              return _vm.$bvModal.show("feedbackModal")
            }
          }
        },
        [_c("i", { staticClass: "fas fa-question" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }